import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import Button from '../../Button/Button';
import styles from './DeleteUserFromGuildModal.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { deleteUserFromGuildAction } from '../../../store/reducers/Guild/guildRequest';
import { clearData } from '../../../store/reducers/Guild/slice';
import { GuildActionsName } from '../../../store/reducers/Guild/guildType';
import cn from 'classnames';
import Loader from '../../Loader/Loader';
const DeleteUserFromGuildModal = ({ closeModal, userName, userId, guildId }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { error, pending, isDataSent } = useAppSelector((state) => state.guild);
    const deleteUserFromGuild = () => {
        dispatch(deleteUserFromGuildAction({ userId, guildId }));
    };
    useEffect(() => {
        if (!error && isDataSent.includes(GuildActionsName.DELETE_USER_FROM_GUILD)) {
            closeModal();
            dispatch(clearData(GuildActionsName.DELETE_USER_FROM_GUILD));
        }
    }, [error, isDataSent, dispatch, closeModal, pending]);
    return (_jsxs(Modal, Object.assign({ background: true, closeModal: closeModal }, { children: [_jsx(Heading, { className: styles.heading, title: `Are you sure you want to delete ${userName} from guild?` }), pending.includes(GuildActionsName.DELETE_USER_FROM_GUILD) ? (_jsx(Button, { className: cn('w-100'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { onClick: deleteUserFromGuild, size: '100', height: 'sm', text: t('delete') }))] })));
};
export default DeleteUserFromGuildModal;
